import { render, staticRenderFns } from "./BaseDistanceList.vue?vue&type=template&id=4817fdb2&lang=pug"
import script from "./BaseDistanceList.vue?vue&type=script&lang=js"
export * from "./BaseDistanceList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports